import { Injectable, Injector } from '@angular/core';
import { BaseApiService } from '@carm/_core/baseapi.service';
import { Observable, of } from 'rxjs';
import { IGetPaymentArrangementTypesResponse } from '../models/payments.model';
import {
  IPaymentArrangementListResponse,
  IPaymentArrangementListDetailResponse,
  IPaymentArrangementRequest,
  IPaymentArrangementResponse,
  ICreateStatus,
  ICreateStatusResponse
} from '../models/payment-arrangements-api.model';
import { LoaderSpinnerTypes } from '@carm/_core';
import { map } from 'rxjs/operators';

@Injectable()
export class PaymentArrangementService extends BaseApiService {

  private get basePromiseToPayUrlBP(): string {
    return `${this.endPointBP}/promise-to-pay`;
  }

  constructor(protected injector: Injector) {
    super(injector);
  }

  public getArrangementTypes(): Observable<IGetPaymentArrangementTypesResponse> {
    // TBD

    const mock: IGetPaymentArrangementTypesResponse = {
      typeList: [
        {
          key: 'P1',
          value: this.translateService.instant(
            'application_features.payments.sections.arrangements.common.12months'
          ),
        },
        {
          key: 'P2',
          value: this.translateService.instant(
            'application_features.payments.sections.arrangements.common.6months'
          ),
        },
        {
          key: 'P3',
          value: this.translateService.instant(
            'application_features.payments.sections.arrangements.common.3months'
          ),
        },
      ],
    };

    return of(mock);
  }

  public getPaymentArrangementList(): Observable<IPaymentArrangementListResponse> {
    const endPoint = `${this.basePromiseToPayUrlBP}/general`;
    return this.httpAuthGet<IPaymentArrangementListResponse>(endPoint, null, LoaderSpinnerTypes.AgGrid);
  }

  public getPaymentArrangement(
    paymentArrangementId: string
  ): Observable<IPaymentArrangementResponse> {
    const endPoint = `${this.basePromiseToPayUrlBP}/general/${paymentArrangementId}`;
    return this.httpAuthGet<IPaymentArrangementListResponse>(endPoint).pipe(map(listResponse => {
      return (listResponse.promiseToPays?.length > 0) ? listResponse.promiseToPays[0] : null; // get payment by id returns an array for some reason. return the first item...
    }));
  }

  public getPaymentArrangementDetail(
    paymentArrangementId: string
  ): Observable<IPaymentArrangementListDetailResponse> {
    const endPoint = `${this.basePromiseToPayUrlBP}/payment-details/${paymentArrangementId}`;
    return this.httpAuthGet<IPaymentArrangementListDetailResponse>(endPoint, null, LoaderSpinnerTypes.AgGrid);
  }

  public createPaymentArrangement(
    par: IPaymentArrangementRequest
  ): Observable<IPaymentArrangementResponse> {
    const endPoint = `${this.basePromiseToPayUrlBP}/create`;
    return this.httpAuthPost<IPaymentArrangementResponse>(endPoint, par);
  }

  public activatePaymentArrangement(
    par: IPaymentArrangementRequest
  ): Observable<IPaymentArrangementResponse> {
    const endPoint = `${this.basePromiseToPayUrlBP}/activate`;
    return this.httpAuthPost<IPaymentArrangementResponse>(endPoint, par);
  }

  public getCreateStatus(): Observable<ICreateStatus> {
    const endPoint = `${this.basePromiseToPayUrlBP}/create-status`;
    return this.httpAuthGet<ICreateStatusResponse>(endPoint);
  }
}
